import {ReactNode} from "react";
import {Helmet} from "react-helmet-async";
import {Link} from "react-router";

import NotFoundHamster from "@/assets/images/not-found-hamster.svg";
import {Button} from "@/components/button/Button.tsx";
import {Card} from "@/components/card/Card.tsx";
import ContentContainer from "@/components/layout/ContentContainer.tsx";

interface NotFoundPageProps {
  title?: string;
  message?: string;
  redirectComponent?: ReactNode;
}

export const NotFoundPage = ({
  title = "Page Not Found",
  message = "Sorry, the page you're looking for cannot be found.",
  redirectComponent = (
    <Button as={Link} to="/dashboard" className="mt-3">
      Go to Dashboard
    </Button>
  ),
}: NotFoundPageProps) => {
  return (
    <ContentContainer title={`404 - ${title}`}>
      <Helmet>
        <title>404 - {title}</title>
      </Helmet>
      <Card variant="white" className="d-flex flex-column align-items-center gap-4">
        <img src={NotFoundHamster} height={106} width={126} alt="404 - Page Not Found" />
        <div className="pulseTextH1Bold">{title}</div>
        <div>{message}</div>
        {redirectComponent}
      </Card>
    </ContentContainer>
  );
};
